export class UserRole {
	public static ADMIN:number = 0;
	public static MODERATOR:number = 1;
	public static USER:number = 2;
}